export const lenisStore = { current: null };
